import { render, staticRenderFns } from "./CourierServiceDetail.vue?vue&type=template&id=d5b13758&scoped=true&"
import script from "./CourierServiceDetail.vue?vue&type=script&lang=js&"
export * from "./CourierServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b13758",
  null
  
)

export default component.exports